import { Component, Inject, ViewChild } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-calendar-picker-dialog',
  templateUrl: './calendar-picker-dialog.component.html',
  styleUrls: ['./calendar-picker-dialog.component.scss'],
})
export class CalendarPickerDialogComponent {
  @ViewChild(MatCalendar) calendar?: MatCalendar<Date>;

  selected: Date;
  startAt: Date;
  minDate: Date;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { selected?: Date },
    private dialogRef: MatDialogRef<CalendarPickerDialogComponent>
  ) {
    const now = new Date();
    this.minDate = this.atStartOfDay(now);

    const initial = data?.selected ? new Date(data.selected) : now;
    const initialDay = this.atStartOfDay(initial);
    const clampedInitial = this.clampToMin(initialDay);

    this.startAt = clampedInitial;
    this.selected = clampedInitial;
  }

  choose(date: Date): void {
    this.setSelection(date);
  }

  useToday(): void {
    const today = this.atStartOfDay(new Date());
    this.setSelection(today);
  }

  pickRelative(options: { days?: number; months?: number; years?: number }): void {
    const target = this.shiftFromSelection(options);
    this.setSelection(target);
  }

  close(): void {
    this.dialogRef.close();
  }

  confirm(): void {
    this.dialogRef.close(this.selected);
  }

  private shiftFromSelection(options: { days?: number; months?: number; years?: number }): Date {
    const { days = 0, months = 0, years = 0 } = options;
    const base = this.atStartOfDay(this.selected || new Date());
    const target = new Date(base);
    target.setFullYear(target.getFullYear() + years);
    target.setMonth(target.getMonth() + months);
    target.setDate(target.getDate() + days);
    return target;
  }

  private atStartOfDay(date: Date): Date {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  private setSelection(date: Date): void {
    const clamped = this.clampToMin(date);
    this.selected = clamped;
    // Update calendar view so it snaps to the newly selected date.
    if (this.calendar) {
      this.calendar.activeDate = clamped;
    }
  }

  private clampToMin(date: Date): Date {
    return date.getTime() < this.minDate.getTime() ? new Date(this.minDate) : date;
  }
}
